import * as Sentry from "@sentry/react";
import { Route as ReactRouterRoute } from "react-router-dom";

// In order to enable Sentry parametrized transaction names, with react-router v5, we have
// to wrap the react-router Route with a Sentry HOC.
// After we migrate to react-router v6, we won't have to individually wrap each usage of Route.
//
// https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/#parameterized-transaction-names
export const Route = Sentry.withSentryRouting(ReactRouterRoute);
